import { render } from "./UiChart.vue?vue&type=template&id=ab95baac&ts=true"
import script from "./UiChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ab95baac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab95baac', __exports__)) {
    api.reload('ab95baac', __exports__)
  }
  
  module.hot.accept("./UiChart.vue?vue&type=template&id=ab95baac&ts=true", () => {
    api.rerender('ab95baac', render)
  })

}


export default __exports__